export const INITIAL_ZOOM = 10.12;
